@if (
  {
    paginationData: paginationData$ | async,
    isLoading: isLoading$ | async,
    currentError: currentError$ | async,
    resources: resources$ | async,
    onGlobalRefresh: onGlobalRefresh$ | async
  };
  as STATE
) {
  <section class="subscriber-channel-list-page">
    <page-header> <mediatype-stat-cards></mediatype-stat-cards></page-header>

    <search-bar
      [count]="STATE.resources?.length"
      [searchPlaceholder]="'Rechercher un élément ici'"
      [allowAddButton]="false"
      (search)="onSearch($event)"
    >
    </search-bar>

    @if (!STATE.isLoading && !STATE.currentError) {
      <subscriber-channel-datatable [channels]="$any(STATE.resources)" />
      <mat-paginator
        *ngIf="STATE.resources && STATE.paginationData as pagination"
        (page)="handlePageEvent($event)"
        [length]="pagination.fullyItems"
        [pageIndex]="
          STATE.resources && pagination.page ? pagination.page - 1 : 0
        "
        [pageSizeOptions]="[10, 25, 50]"
        [pageSize]="pagination.itemPerPage"
      >
      </mat-paginator>
    }

    @if (STATE.isLoading || STATE.currentError) {
      <loading-or-error
        (retry)="refreshData()"
        [error$]="currentError$"
        spinnerSize="lg"
      ></loading-or-error>
    }
  </section>
}
